var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5416 0.791616H32.4583C45.5751 0.791616 56.2083 11.4246 56.2083 24.5416V32.4583C56.2083 45.5748 45.5751 56.2082 32.4583 56.2082H24.5416C11.4249 56.2082 0.791616 45.5748 0.791616 32.4583V24.5416C0.791616 11.4246 11.4249 0.791616 24.5416 0.791616Z",
    fill: "url(#paint0_linear_1_494)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3891 25.2214C42.3936 25.3023 42.3877 25.3845 42.3675 25.467L40.5607 32.7235C40.4695 33.0887 40.1432 33.3462 39.7681 33.3483L28.9274 33.4033C28.926 33.4033 28.9247 33.4033 28.9232 33.4033H18.0825C17.7053 33.4033 17.3767 33.1449 17.2857 32.7776L15.4789 25.4934C15.458 25.4091 15.4521 25.3244 15.4573 25.2414C14.7583 25.0206 14.25 24.3638 14.25 23.59C14.25 22.6345 15.0236 21.8577 15.9746 21.8577C16.9256 21.8577 17.6993 22.6345 17.6993 23.59C17.6993 24.1276 17.4538 24.6085 17.0696 24.9269L19.3317 27.2151C19.9034 27.7935 20.6967 28.1255 21.5083 28.1255C22.468 28.1255 23.383 27.6675 23.9592 26.901L27.6769 21.9547C27.3646 21.6415 27.1711 21.2086 27.1711 20.7311C27.1711 19.776 27.9448 18.9988 28.8958 18.9988C29.8468 18.9988 30.6204 19.776 30.6204 20.7311C30.6204 21.1942 30.4373 21.6142 30.1413 21.9254C30.1423 21.9267 30.1436 21.9279 30.1445 21.9292L33.8351 26.889C34.4112 27.6628 35.3294 28.1255 36.2918 28.1255C37.1109 28.1255 37.8812 27.805 38.4603 27.2236L40.7366 24.9375C40.3443 24.6196 40.0923 24.1344 40.0923 23.59C40.0923 22.6345 40.866 21.8577 41.817 21.8577C42.768 21.8577 43.5417 22.6345 43.5417 23.59C43.5417 24.3429 43.0592 24.9839 42.3891 25.2214ZM40.3844 35.9868C40.3844 35.5318 40.0166 35.1624 39.5631 35.1624H18.3198C17.8662 35.1624 17.4985 35.5318 17.4985 35.9868V37.966C17.4985 38.4218 17.8662 38.7908 18.3198 38.7908H39.5631C40.0166 38.7908 40.3844 38.4218 40.3844 37.966V35.9868Z",
    fill: "#FE5868"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_494",
    x1: 32.7855,
    y1: 89.7855,
    x2: 89.7855,
    y2: 24.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F857A6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.41deffd46235ddd624debdae62df6bce.svg";
export { ForwardRef as ReactComponent };